module.exports = __webpack_public_path__ + "img/gaoyunpeng.71773b50.png";